/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomerRefund = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10.557 2h8.886l-1.807 4.819 3.255 4.063.027.043c1.074 1.664 1.417 3.796.717 5.727v.002a5.669 5.669 0 0 1-.187.452A1 1 0 0 1 21.8 18.6c-1.635 2.18-3.557 3.285-5.083 3.84-.76.276-1.42.416-1.898.487a7.354 7.354 0 0 1-.74.071l-.051.002H14c-2.08 0-3.898-.26-5.196-.52a23.33 23.33 0 0 1-1.536-.359A15.3 15.3 0 0 1 6.847 22H2v-8h4.764l1.36-.68a6.767 6.767 0 0 1 .958-2.395l.027-.043 3.255-4.063zm3.423 6-3.229 4.032a.996.996 0 0 1 .25-.032h6a1 1 0 0 1 .98 1.196v.002l-.001.002-.001.006-.004.017a9.51 9.51 0 0 1-.245.875 9.78 9.78 0 0 1-.872 1.917 7.578 7.578 0 0 1-.701.985h2.716c.152 0 .275-.05.415-.195.162-.167.325-.444.467-.836.46-1.27.257-2.733-.49-3.919L16.02 8zm1.827-2 .75-2h-3.114l.75 2zM12 19a1 1 0 1 1 0-2c1.503 0 2.483-.915 3.143-2.014a7.39 7.39 0 0 0 .49-.986h-4.397L8 15.618v4.628c.308.08.713.177 1.196.273 1.201.24 2.883.48 4.8.481h.017l.097-.005a5.32 5.32 0 0 0 .415-.047 7.792 7.792 0 0 0 1.508-.388 8.72 8.72 0 0 0 2.67-1.56zm-6-3H4v4h2zM5.586 5 4.293 3.707l1.414-1.414L9.414 6 5.707 9.707 4.293 8.293 5.586 7H2V5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomerRefund as CustomerRefund };
